module.exports = __webpack_public_path__ + "img/about-img-1.69e88ea5.jpg";